@if (taxObject?.propertyType; as propertyType) {
  <div class="row">
    <div class="col-12">
      <p class="mb-2">
        <strong>
          Typ nieruchomości
        </strong>
      </p>
    </div>
    <div class="col-12">
      <app-label label="Typ:">
        {{ propertyType }}
      </app-label>
    </div>
  </div>
  <br>
}
<div class="row">
  <div class="col-12">
    <p class="mb-2">
      <strong>
        Położenie
      </strong>
    </p>
  </div>
  <div class="col-md-4">
    <app-label label="Miejscowość:">
      {{ taxObject?.city || '-' }}
    </app-label>
  </div>
  <div class="col-md-8">
    <app-label label="Ulica:">
      {{ taxObject?.street || '-' }}
    </app-label>
  </div>
  <div class="col-12">
    <app-label label="Numer domu:">
      {{ taxObject?.houseNumber || '-' }}
    </app-label>
  </div>
  <div class="col-12">
    <app-label [label]="(application() | additionalLocationDescriptionLabel) + ':'">
      {{ taxObject?.additionalLocationDescription || '-' }}
    </app-label>
  </div>
</div>
<br>
<div class="row">
  <div class="col-12">
    <p class="mb-2">
      <strong>
        Identyfikacja
      </strong>
    </p>
  </div>
  <div class="col-12">
    <app-label [label]="(application() | hasLandRegisterLabel) + ':'">
      {{ taxObject?.hasLandRegister ? 'Tak' : 'Nie' }}
    </app-label>
  </div>
  @if (taxObject?.landRegisterNumber; as landRegisterNumber) {
    <div class="col-md-4">
      <app-label label="Numer księgi wieczystej:">
        {{ landRegisterNumber || '-' }}
      </app-label>
    </div>
  }
  @if (taxObject?.documentCollectionNumber; as documentCollectionNumber) {
    <div class="col-12">
      <app-label label="Numer zbioru dokumentów:">
        {{ documentCollectionNumber }}
      </app-label>
    </div>
  }
  @if (taxObject?.notarialDeedNumber; as notarialDeedNumber) {
    <div class="col-md-4">
      <app-label label="Numer aktu notarialnego:">
        {{ notarialDeedNumber || '-' }}
      </app-label>
    </div>
  }
  @if (taxObject?.notarialDeedDate; as notarialDeedDate) {
    <div class="col-md-6">
      <app-label label="Data aktu notarialnego:">
        {{ (notarialDeedDate | date) || '-' }}
      </app-label>
    </div>
  }
  @if (taxObject?.contractNumber; as contractNumber) {
    <div class="col-md-4">
      <app-label label="Numer umowy:">
        {{ taxObject?.contractNumber || '-' }}
      </app-label>
    </div>
  }
  @if (taxObject?.contractDate; as contractDate) {
    <div class="col-md-4">
      <app-label label="Data umowy:">
        {{ (taxObject?.contractDate | date) || '-' }}
      </app-label>
    </div>
  }
  <div class="col-md-12">
    <app-label label="Forma władania:">
      {{ taxObject?.possessionForm || '-' }}
    </app-label>
  </div>
  @if (taxObject?.isPartOfNatureReserve | canDisplay) {
    <div class="col-md-12">
      <app-label label="Czy las wchodzi w skład rezerwatów przyrody i parków narodowych?:">
        {{ taxObject?.isPartOfNatureReserve ? 'Tak' : 'Nie' }}
      </app-label>
    </div>
  }
  @if (taxObject?.taxExemptType; as taxExemptType) {
    <div class="col-md-12">
      <app-label label="Podlega zwolnieniu/uldze?:">
        {{ taxExemptType }}
      </app-label>
    </div>
  }
  @if (taxObject?.isTaxExempt | canDisplay) {
    <div class="col-md-12">
      <app-label label="Czy las podlega zwolnieniu z podatku?:">
        {{ taxObject?.isTaxExempt ? 'Tak' : 'Nie' }}
      </app-label>
    </div>
  }
  @if (taxObject?.taxExemptionBasis; as taxExemptionBasis) {
    <div class="col-12">
      <app-label label="Podstawa zwolnienia z podatku:">
        {{ taxExemptionBasis || '-' }}
      </app-label>
    </div>
  }
  @if (taxObject?.groundType; as groundType) {
    <div class="col-md-4">
      <app-label label="Typ gruntu:">
        {{ groundType || '-' }}
      </app-label>
    </div>
  }
  @if (taxObject?.usageClass; as usageClass) {
    <div class="col-8">
      <app-label label="Klasa użytku:">
        {{ usageClass }}
      </app-label>
    </div>
  }
  <div class="col-md-4">
    <app-label label="Numer obrębu:">
      {{ taxObject?.districtNumber || '-' }}
    </app-label>
  </div>
  <div class="col-md-4">
    <app-label label="Numer działki:">
      {{ taxObject?.parcelNumber || '-' }}
    </app-label>
  </div>
  @if (taxObject?.areaHa | canDisplay) {
    <div class="col-md-4">
      <app-label label="Powierzchnia:">
        {{ taxObject?.areaHa | number }} (ha)
      </app-label>
    </div>
  }
</div>
@if (taxObject?.areaType; as areaType) {
  <br>
  <div class="row">
    <div class="col-12">
      <p class="mb-2">
        <strong>
          Powierzchnia
        </strong>
      </p>
    </div>
    <div class="col-12">
      <app-label label="Typ powierzchni:">
        {{ areaType }}
      </app-label>
    </div>
    @if (taxObject?.areaM2 | canDisplay) {
      <div class="col-md-6">
        <app-label label="Łączna powierzchnia:">
          {{ taxObject?.areaM2 | number }} (m<sup>2</sup>)
        </app-label>
      </div>
    }
    @if (taxObject?.areaAbove22m | canDisplay) {
      <div class="col-md-6">
        <app-label label="Powierzchnia powyżej wysokości 2,2m:">
          {{ taxObject?.areaAbove22m | number }} (m<sup>2</sup>)
        </app-label>
      </div>
    }
    @if (taxObject?.areaBetween14and22m | canDisplay) {
      <div class="col-md-6">
        <app-label label="Powierzchnia pomiędzy wysokością 1,4m a 2,2m:">
          {{ taxObject?.areaBetween14and22m | number }} (m<sup>2</sup>)
        </app-label>
      </div>
    }
  </div>
}
